<div class="gauge-label low">{{ 'confidenceGauge.confidence.low' | translate }}</div>
<div class="arc-container" [style.--background-color]="backgroundColor">
    <div class="circular-gauge"
         [style.--angle-start]="conicFromDegree + 'deg'"
         [style.--angle-end]="conicToDegree + 'deg'"
         [style.--thickness]="thickness"
         [style.--gradient]="gradient">
        <div class="progress" [style.--progress-percent]="progressPercentage$ | async"></div>
        <div class="value-container">
            <div [upscRotaryCounter]="value" class="value" (click)="openScoreInfoDialog($event)"></div>
            <div [class.show]="showCoverageResult$ | async" class="coverage">
                <span *ngIf="value <= coverageThreshold">{{ 'confidenceGauge.coverage.noCoverage' | translate }}</span>
                <span *ngIf="value > coverageThreshold">{{ 'confidenceGauge.coverage.withCoverage' | translate }}</span>
            </div>
        </div>
    </div>
</div>
<div class="gauge-label high">{{ 'confidenceGauge.confidence.high' | translate }}</div>
